import { EventFormData } from '../EventForm/eventFormTypes'
import { buildRepeatingEventConfig, buildTimingFields } from '../EventForm/recurringEventFormHelpers'
import { ApplyChangesOption } from '../JobDrawer/Modals/ScheduledEventsChangesModal'
import { TaskCompletionScope, TaskCompletionScopes } from '../scheduleApi'

export type TaskEditSnapshot = {
  title: string
  notes: string
  frozen: boolean
  formValues: EventFormData
}

const comparableValues = ({ title, notes, frozen, formValues }: TaskEditSnapshot) => {
  const { actualStartDateTime, endDateTime, durationMinutes } = buildTimingFields(formValues)

  return {
    title: title.trim(),
    notes: notes.trim(),
    frozen,
    start: actualStartDateTime.valueOf(),
    end: endDateTime.valueOf(),
    durationMinutes,
    allDay: formValues.isAllDay,
    crewMemberIds: formValues.selectedCrew.map(member => member.id).sort((a, b) => a - b),
    crewLeadId: formValues.crewLeadId,
    sendCrewLeadNotifications: formValues.sendCrewLeadNotifications,
    repeatingEventConfig: buildRepeatingEventConfig(formValues),
  }
}

export const hasNonCompletionChanges = (original: TaskEditSnapshot, current: TaskEditSnapshot): boolean => {
  return JSON.stringify(comparableValues(original)) !== JSON.stringify(comparableValues(current))
}

export const mapApplyChangesOptionToScope = (option: ApplyChangesOption): TaskCompletionScope => {
  if (option === 'this-and-future') {
    return TaskCompletionScopes.ThisAndFuture
  }
  if (option === 'selected-dates') {
    return TaskCompletionScopes.SelectedDates
  }
  return TaskCompletionScopes.ThisEvent
}
